// ============================================================================
// STATE/PROVINCE SERVICE (read-only)
// ============================================================================

import { get } from '../client/axiosClient';
import { stateProvinceEndpoints, STATE_PROVINCE_BASE_PATH } from '../endpoints/stateProvince.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type { ApiResponse, PaginatedResponse, ID } from '../types';
import type {
  StateProvince,
  StateProvinceListItem,
  StateProvinceSearchRequest,
} from '../types/stateProvince.types';

class StateProvinceService {
  async getAll(params?: StateProvinceSearchRequest): Promise<PaginatedResponse<StateProvinceListItem>> {
    const endpoint = params
      ? buildEndpointWithQuery(STATE_PROVINCE_BASE_PATH, params)
      : stateProvinceEndpoints.list();

    const response = await get<any>(endpoint);
    const raw = response.data;
    const pagedResult = raw?.data ?? {};
    return {
      success: raw?.success ?? false,
      message: raw?.message,
      data: pagedResult.items ?? [],
      pagination: {
        currentPage: pagedResult.page ?? 1,
        pageSize: pagedResult.pageSize ?? 20,
        totalPages: pagedResult.totalPages ?? 0,
        totalItems: pagedResult.totalCount ?? 0,
        hasNextPage: pagedResult.hasNext ?? false,
        hasPreviousPage: pagedResult.hasPrevious ?? false,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<StateProvince>> {
    const response = await get<ApiResponse<StateProvince>>(stateProvinceEndpoints.getById(id));
    return response.data;
  }
}

export const stateProvinceService = new StateProvinceService();
export default stateProvinceService;
